import React from "react";

const NewFileCard = (props) => {
  const {
    index,
    onFileChange,
    onDescriptionChange,
    handleRemove, file
  } = props;

  return (
    <div
      key={index}
      className="input-group mb-4 p-2 "
      style={{
        border: "2px solid #e8e8e8",
        borderRadius: 6,
      }}>
      <div className='d-flex justify-content-between' style={{ width: '100%', padding: 8 }}>
        <span style={{ fontSize: 14, fontWeight: 500 }}>
          New File
        </span>

        <button
          className="btn btn-sm btn-primary "
          type="button"
          style={{ height: 25, width: 25, fontSize: 11 }}
          onClick={handleRemove}>
          X
        </button>
      </div>
      <input
        type="file"
        className="form-control w-100 mb-2"
        onChange={(e) => onFileChange(e, index)}
      />
      <input
        type="text"
        className="form-control w-100"
        placeholder="File Description - Required"
        value={file.description}
        onChange={(e) => onDescriptionChange(e, index)}
        required
      />
    </div>
  );
};

export default NewFileCard;
